module.exports = __webpack_public_path__ + "img/poo-bolt.34fcfc31.svg";